import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { AccreditationCentersListContainer } from 'components';


const mapState = (state: IRootState) => ({
    accreditationCentersList: state.accreditationCenters.accreditationCenters,
    accreditationCenterDetails: state.accreditationCenters.accreditationCenterDetails,
    exams: state.exams.exams,
    qualifications: state.qualifications.qualifications,
    accreditationCenterQualifications: state.accreditationCenters.accreditationCenterQualifications,
    qualificationId: state.auth.auth ? state.auth.auth.profile.qualificationId : undefined,
    apiError: state.errors.error,
    isAsc: state.auth.isAsc,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getQualifications: dispatch.qualifications.getQualifications,
    getAccreditationCenterQualifications: dispatch.accreditationCenters.getAccreditationCenterQualifications,
    getAccreditationCenters: dispatch.accreditationCenters.getAccreditationCenters,
    getAccreditationCenter: dispatch.accreditationCenters.getAccreditationCenter,
    getExams: dispatch.exams.getExamFilteredList,
    clearExams: () => dispatch.exams.setExams(null),
    clearAccreditationCenterQualifications: () => dispatch.accreditationCenters.setQualifications(null),
    clearAccreditationCenterDetails: () => dispatch.accreditationCenters.setAccreditationCenterDetails(null),
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(AccreditationCentersListContainer);
